// Búsqueda por nombre de las listas con ciclo de vida: sin distinguir mayúsculas ni acentos.

const fold = (text: string) =>
    text
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase()
        .trim();

/** `true` si el nombre contiene lo buscado; una búsqueda vacía no filtra. */
export function matchesNameSearch(name: string, query: string): boolean {
    const needle = fold(query);
    return needle === '' || fold(name).includes(needle);
}
